'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { TABLE } from 'reporting-visualizations/constants/visualizationTypes';
import { Directions, TableVisualization } from 'reporting-visualizations/visualizations/table/tableRecords';
import { isTotalColumn, toTotalAlias } from '../../modify/totals/totals';
import { getLinkAlias } from '../../resolve/link';
import { SortOrders } from '../../schema/sort-records';
import { getMeasures } from '../../utils/column-utils';
import { getReportColumnsEncodings } from '../../utils/report-utils';
import { getPrimaryDataset } from 'reporting-data/v2/dataset/datasetGetters';
import { COLUMN_ROLES } from 'reporting-data/constants/relationalReports';
const getTotalsDataset = (report, dataset) => {
  const {
    columns
  } = report;
  const sampleRow = !dataset.data.isEmpty() && dataset.data.first();
  const totalRow = columns.filter(column => !isTotalColumn(column)).map(column => {
    if (column.role === COLUMN_ROLES.DIMENSION || !sampleRow) {
      return undefined;
    }
    return sampleRow.get(toTotalAlias(column.alias));
  });
  return dataset.set('data', List.of(totalRow));
};
const getLinkColumns = (report, dataset) => {
  if (dataset.data.isEmpty()) {
    return ImmutableMap();
  }
  const sampleRow = dataset.data.first();
  return report.columns.filter(({
    alias
  }) => sampleRow.has(getLinkAlias(alias))).map(({
    alias
  }) => getLinkAlias(alias));
};
export const mapTableToVisual = (report, datasets, reportOptions, params = {}) => {
  const primaryDataset = getPrimaryDataset(datasets);
  const {
    columns
  } = report;
  const encodings = getReportColumnsEncodings(report);
  const {
    onTableCellLinkClick
  } = params;
  const isSearchRequest = getMeasures(columns).isEmpty();
  const showTotals = report.visual.options.showTotals && !isSearchRequest;
  const totals = showTotals && getTotalsDataset(report, primaryDataset);
  const linkColumns = getLinkColumns(report, primaryDataset);
  const activeSort = report.sorts && report.sorts.get(0);
  const getColumnSortDirection = alias => activeSort && activeSort.column === alias ? activeSort.order === SortOrders.ASCENDING ? Directions.ascending : Directions.descending : undefined;
  const paginationSize = primaryDataset && primaryDataset.get('paginationSize');
  const reportLimit = reportOptions && reportOptions.get('limit');
  const pages = paginationSize && reportLimit && Math.ceil(paginationSize / reportLimit);
  return TableVisualization({
    type: TABLE,
    data: Object.assign({
      primary: primaryDataset
    }, showTotals ? {
      totals
    } : {}),
    pages,
    columns: encodings
    //.map(({ column, options }) => {field: column.alias})
    .map(({
      column,
      options
    }) => {
      const field = column.alias;
      return {
        dataset: 'primary',
        field,
        direction: getColumnSortDirection(field),
        linkField: linkColumns.get(field),
        formattingType: options.getIn(['format', 'type']),
        formattingObject: options.get('format'),
        style: options
      };
    }),
    footer: showTotals ? 'totals' : undefined,
    showTotals,
    onTableCellLinkClick
  });
};